import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { closeMap } from "../../state/map";
import { Navbar } from "../Navbar";
import { Hero } from "./Hero";
import { Description } from "./Description";
import { TestimonialsCarousel } from "./TestimonialsCarousel";
import { MapsShowcase } from "./MapsShowcase";
import { Statistics } from "./Statistics";
import { LogoCarousel } from "./LogoCarousel";
import { FeatureCards } from "./FeatureCards";
import { useAppDispatch } from "@/state/types";

const Dashboard = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(closeMap());
  }, [dispatch]);

  return (
    <Box width="100%">
      <Navbar />
      <Hero />
      <TestimonialsCarousel />
      <LogoCarousel/>
      <Description />
      {/* <MapScroll/> */}
      <MapsShowcase />
      <FeatureCards />
      <Statistics />
    </Box>
  );
};

export default Dashboard;

